module.exports = __webpack_public_path__ + "05a3e816ffe51b5eb75f45d3ec4638f6.jpg";